// src/pages/Reports/components/ViewReport.tsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BackIcon from "@/styles/all-images/icons/back-button.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import actionsHandler from "@/store/actions/actionHandler";
import { toast } from "react-toastify";

const ViewReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const [report, setReport] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchReport = async () => {
      setIsLoading(true);
      try {
        const { authenticatedCall } = actionsHandler("viewReport");
        const response = await dispatch(
          authenticatedCall({
            method: "get",
            customParams: [id!],
          }) as any,
        );

        if (response.ok) {
          setReport(response.data);
        } else {
          toast.error(response.data?.message || "Failed to fetch report");
        }
      } catch (error) {
        console.error("Error fetching report:", error);
        toast.error("Failed to fetch report");
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchReport();
    }
  }, [id, dispatch]);

  return (
    <div className="tw-relative">
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-left-0 tw-right-0 tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <button
                onClick={() => navigate(-1)}
                className="tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer hover:tw-opacity-80"
              >
                <img
                  src={BackIcon}
                  alt="Back Icon"
                  className="tw-cursor-pointer tw-w-6 tw-h-6"
                />
              </button>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                {report?.title} Report
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-mt-[147px] tw-px-8 tw-pb-8">
        <div className="tw-p-6">
          <div className="tw-bg-white tw-border tw-rounded-2xl tw-border-[#E9EAEB] tw-p-8">
            <div
              dangerouslySetInnerHTML={{ __html: report?.iframe_tag }}
              className="tw-mx-auto tw-flex tw-justify-center tw-items-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReport;
